
import vue from 'vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Badge from 'vux/src/components/badge/index.vue'

import {
initWxJSSDK,
autoSign,
getWorkOrderAmount
} from '../../common/js/api.js'

export default {
components: {
Grid,
GridItem,
Badge
},
methods: {
getProfile() {
let self = this
},

initLocation() {
let self = this
self.$wechat.getLocation({
type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
fail: function(res) {
console.error(res)
},
success: function(res) {
var latitude = res.latitude 
var longitude = res.longitude 
var speed = res.speed 
var accuracy = res.accuracy 
if ((latitude + '').length > 13) {
latitude = parseFloat(latitude).toFixed(10)
}
if ((longitude + '').length > 13) {
longitude = parseFloat(longitude).toFixed(10)
}
autoSign({ data: { latitude: latitude, longitude: longitude } })
}
})
}
},
data() {
return {
workOrderAmount: 0,
entity: {
avatar: ''
}
}
},
created() {
let self = this
initWxJSSDK()
vue.wechat.ready(function(res) {
self.initLocation()
})
getWorkOrderAmount({ data: {} }).then(function(data) {
self.workOrderAmount = data.Content
})
}
}



// WEBPACK FOOTER //
// ./src/components/support/Index.vue